import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
  country: Joi.string().allow(''),
  province: Joi.string().allow(''),
  city: Joi.string().allow(''),
  street: Joi.string().allow(''),
  suit_number: Joi.string().allow(''),
  post_code: Joi.string().allow(''),
  name: Joi.string().allow(''),
  description: Joi.string().allow(''),
  area_in_square_foot: Joi.string().allow(''),
  seating_capacity: Joi.string().allow(''),
  status: Joi.string().allow(''), // 0：停用，1：自用，2：出租；3：自用+出租混合（当设为2或3时，才需要填单价个价格单位）
  price_per_unit: Joi.string().allow(''),
  currency_unit: Joi.string().allow(''), // 0:CAD, 1:USD, 2:RMB
  price_unit: Joi.string().allow(''), // 0:按小时计价，1：按次计价，2：按天计价
});


export default function addClassroom(schoolId, classroomInfo) {

  if(!schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school ID')
      })
    })
	}

  let validateResult = Joi.validate(classroomInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/classroom_list/${schoolId}/`,
    'data': JSON.stringify(classroomInfo),
    'method': 'POST',
    'token': localStorage.getItem('token')})
    .then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/classroom/addClassroom.js